import * as Yup from "yup"

const NewTemplateValidation = {
    templateName: Yup.string().required('Il campo è obbligatorio'),
    templateType: Yup.string().required('Il campo è obbligatorio')

}

export default Yup.object()
    .shape(
        NewTemplateValidation,
    )
    .required()
